import {
  timeDiff,
  utcStringToLocalDatetimeConverter
} from "./datetimeHandlers";
import * as localforage from "localforage";
import { getDeviceTaskAPI } from "../apis/getDeviceTaskAPI";
import { setVNCAPI } from "../apis/setVNCAPI";
import {
  androidOraVersion,
  windowsOraVersion
} from "../config/oraVersionForVncLink";
import { APP_ENV } from "@/APP_ENV";

export const oraVersionNum = (versionString, osType) => {
  const env = APP_ENV.REACT_APP_ENV;
  if (osType === "android") {
    if (env === "development" || env === "testing" || env === "staging") {
      // only ora version of 'dev' and 'staging' from android are '2.x.x-env'
      return parseInt(versionString.split("-")[0].split(".").join(""));
    }
  }

  if (osType === "windows" || (osType === "android" && env === "production"))
    return parseInt(versionString.split(".").join(""));
};

export const handleNewOrOldVnc = deviceData => {
  const osType = deviceData?.os_type;
  const oraVersion = deviceData?.ora_version ?? "";
  const env = APP_ENV.REACT_APP_ENV;

  const ifGetNewVnc = (oraVersion, versionForNewVnc) =>
    oraVersion >= versionForNewVnc;

  if (osType === "linux") {
    return true;
  }

  if (osType === "android") {
    return ifGetNewVnc(oraVersionNum(oraVersion, osType), androidOraVersion);
  }

  if (osType === "windows")
    return ifGetNewVnc(
      oraVersionNum(oraVersion, osType),
      windowsOraVersion[env]
    );

  return false;
};

export const callVncAPI = async (
  device_id,
  deviceData,
  nubisVersion,
  setIsLoading,
  setVNCLink,
  setVNCExpiredDate,
  setDialogContent,
  handleVNCFailedDialogOpen,
  t,
  type = "deviceDetail",
  setTaskStatus
) => {
  setIsLoading(true);
  const newVnc = handleNewOrOldVnc(deviceData);
  const taskResponse = await setVNCAPI(deviceData, nubisVersion, newVnc, type);
  let taskStatus;
  const startGetTaskStatus = async () => {
    taskStatus = await getDeviceTaskAPI(taskResponse.task_id);

    if (taskStatus !== "completed" && taskStatus !== "failed") {
      setTimeout(startGetTaskStatus, 1000);
    }

    if (taskStatus === "completed") {
      setIsLoading(false);
      await localforage.setItem(`${device_id}VNC`, taskResponse.task_data);
      const vncLink = taskResponse.task_data.vnc.server;
      const vncExpiredDateString = taskResponse.task_data.vnc.expired_at;
      setUpVncLinkAndExpiration(
        vncExpiredDateString,
        vncLink,
        setVNCLink,
        setVNCExpiredDate
      );
      const popUp = window.open("about:blank", "_blank");
      popUp.location = vncLink;
      if (popUp == null || typeof popUp == "undefined") {
        alert("Please disable your pop-up blocker and try again.");
      } else {
        popUp.focus();
      }
    }

    if (taskStatus === "failed") {
      let failedText = `${t("tasks.vncConnectionFailed")}`;
      vncConnectionFailed(
        setIsLoading,
        handleVNCFailedDialogOpen,
        setDialogContent,
        failedText
      );
    }

    if (setTaskStatus) {
      setTaskStatus(taskStatus);
    }
  };

  setTimeout(startGetTaskStatus, 1000);
};

export const setUpVncLinkAndExpiration = (
  expiredAtString,
  link,
  setVNCLink,
  setVNCExpiredDate,
  data
) => {
  let timeValid = timeDiff(expiredAtString, undefined, true);
  if (timeValid) {
    if (handleNewOrOldVnc(data)) {
      setVNCLink(link);
    } else {
      setVNCLink(link);
    }
    setVNCExpiredDate(utcStringToLocalDatetimeConverter(expiredAtString));
  } else {
    return false;
  }
};

export const vncConnectionFailed = (
  setIsLoading,
  handleVNCFailedDialogOpen,
  setDialogContent,
  failedText
) => {
  setIsLoading(false);
  handleVNCFailedDialogOpen();
  setDialogContent(failedText);
};
